// @react/hooks/useSecretSecretPolicy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { secretSecretPolicyStore } from '@core/stores';

/**
 * React hook for SecretPolicy operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useSecretSecretPolicy } from '@react/hooks';
 *
 * const SecretPolicyList = observer(() => {
 *   const store = useSecretSecretPolicy();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useSecretSecretPolicy() {
  return secretSecretPolicyStore;
}
